import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8
  }} className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-112">
      <div className="max-w-2xl mx-auto text-[#3D3D3D]" data-id="element-113">
        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-6 lg:mb-8" data-id="element-114">
          Suddenly you're:
        </p>

        <ul className="space-y-4 lg:space-y-5 mb-10 lg:mb-14 list-none pl-0" data-id="element-115">
          {['Moving money around', 'Asking family for help', 'Panicking about wiring', "Afraid you'll lose the house over a number you weren't warned about"].map((item, i) => <li key={i} className="flex items-start gap-3 lg:gap-4 text-lg lg:text-xl" data-id="element-116">
              <AlertCircle className="w-6 h-6 text-[#1B6B3A] flex-shrink-0 mt-1" data-id="element-117" />
              <span data-id="element-118">{item}</span>
            </li>)}
        </ul>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-6" data-id="element-119">
          Here's what nobody tells buyers:
        </p>

        <p className="text-xl lg:text-2xl font-bold text-[#1A1A1A] mb-8 lg:mb-10 leading-snug" data-id="element-120">
          Your closing number "moves" because nobody is coordinating the moving
          parts until the very end.
        </p>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-4 lg:mb-5" data-id="element-121">
          So this isn't a budgeting problem.
        </p>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-6" data-id="element-122">
          It's a coordination problem.
        </p>

        <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose font-medium text-[#1B6B3A]" data-id="element-123">
          And that's exactly what this checklist fixes.
        </p>
      </div>

      <div className="mt-20 lg:mt-28" data-id="element-124">
        <div className="max-w-2xl mx-auto" data-id="element-125">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-6 lg:mb-8" data-id="element-126">
            Closing Number Lock
          </h2>

          <h3 className="text-xl lg:text-2xl font-serif font-semibold text-[#3D3D3D] mb-6 lg:mb-8 italic leading-relaxed" data-id="element-127">
            The Lender–Title–Insurance Coordination Checklist That Stops
            Last‑Minute Cash‑to‑Close Surprises
          </h3>

          <div className="inline-block bg-[#1B6B3A] text-white px-4 py-1.5 text-sm lg:text-base font-bold tracking-wide uppercase rounded-sm mb-8 lg:mb-10" data-id="element-128">
            Includes the 7‑3‑1 Confirmation Calendar
          </div>

          <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-5 lg:mb-6" data-id="element-129">
            If you're within weeks of closing, you don't need more real estate
            videos.
          </p>

          <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-5 lg:mb-6" data-id="element-130">
            You need one thing:
          </p>

          <p className="text-xl lg:text-2xl font-bold text-[#1A1A1A] mb-8 lg:mb-10 leading-snug" data-id="element-131">
            A way to make the closing number stop drifting.
          </p>

          <p className="text-lg lg:text-xl leading-relaxed lg:leading-loose mb-6 lg:mb-8" data-id="element-132">
            Because the "48-hour surprise" is real:
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 mb-8 lg:mb-10" data-id="element-133">
          {['Taxes get adjusted', 'Insurance comes in higher than the quote', 'HOA fees show up late', 'Prepaid interest changes with the closing date', 'Credits get applied incorrectly', 'Title fees update late'].map((item, i) => <li key={i} className="bg-white p-4 lg:p-5 rounded-lg border border-[#1B6B3A]/10 shadow-sm text-[#3D3D3D] text-base lg:text-lg" data-id="element-134">
              {item}
            </li>)}
        </ul>

        <div className="max-w-2xl mx-auto" data-id="element-135">
          <p className="text-lg lg:text-xl leading-relaxed font-medium italic text-[#6B6B6B]" data-id="element-136">
            And buyers find out when it's too late to react calmly.
          </p>
        </div>
      </div>
    </motion.section>;
}